<aside id="esp-sidebar"
  class="box-content! bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800 flex flex-col transition-all duration-100 h-full select-none"
  [ngClass]="isOpen ? 'w-64' : 'min-w-18 w-18'">

  <!-- Sidebar Header / Branding -->
  <div class="h-16 flex items-center px-4 shrink-0" [ngClass]="isOpen ? 'justify-between' : 'justify-center'">
    @if (isOpen) {
    <div class="flex items-center gap-3 font-bold text-base text-gray-900 dark:text-gray-100 min-w-0">
      <div class="w-10 h-10 min-w-10 flex items-center justify-center">
        <img src="logo.png" alt="Indian Railways Logo" class="w-full h-full object-contain">
      </div>
      <span class="whitespace-nowrap truncate font-semibold text-lg text-gray-800 dark:text-gray-100">Indian
        Railways</span>
    </div>
    } @else {
    <div class="w-10 h-10 min-w-10 flex items-center justify-center" [pTooltip]="'Indian Railways'"
      tooltipPosition="right">
      <img src="logo.png" alt="Indian Railways Logo" class="w-full h-full object-contain">
    </div>
    }
  </div>

  <!-- Navigation Menu -->
  <nav class="flex-1 overflow-y-auto px-3.5 py-2 space-y-2 custom-scrollbar hide-scrollbar">

    @for (group of menuItems; track $index) {
    <div>

      @if (group.section.length > 0 && isOpen) {
      <div
        class="min-h-4 text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-2 whitespace-nowrap">
        {{ group.section }}
      </div>
      } @else if (group.section.length > 0 && !isOpen) {
      <div class="flex justify-center items-center mb-2 min-h-4">
        <div class="bg-gray-300 dark:bg-gray-600 mx-auto rounded-full w-1 h-1"></div>
      </div>
      }

      <div class="space-y-1">
        @for (item of group.items; track item.route) {

        <a [routerLink]="item.disabled ? null : item.route" (click)="onMenuItemClick($event, item)"
          [pTooltip]="!isOpen ? item.label : ''" tooltipPosition="right" [attr.aria-label]="item.label"
          class="flex csr items-center rounded-xl transition-colors duration-150 whitespace-nowrap"
          [class.pointer-events-none]="item.disabled" [ngClass]="[
              isOpen ? 'gap-3.5 px-3.5 py-3 justify-between' : 'justify-center px-0 py-3',
              item.disabled
                ? 'text-gray-400 dark:text-gray-500 cursor-not-allowed opacity-75'
                : (isItemActive(item)
                    ? 'bg-indigo-700 dark:bg-indigo-600 text-white font-medium shadow-xs cursor-pointer'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800/70 font-medium cursor-pointer')
            ]">

          <div class="flex items-center gap-3.5 min-w-0">
            <i [class]="item.icon + ' text-xl shrink-0'" [ngClass]="item.disabled
                  ? 'text-gray-400 dark:text-gray-500'
                  : (isItemActive(item) ? 'text-white' : 'text-gray-700 dark:text-gray-300')"></i>

            @if (isOpen) {
            <span class="text-sm font-medium tracking-tight truncate">{{ item.label }}</span>
            }
          </div>

          @if (isOpen && item.badge && !item.disabled) {
          <span class="flex items-center justify-center min-w-7 h-7 px-2 text-xs font-semibold rounded-full shrink-0"
            [ngClass]="isItemActive(item)
                ? 'bg-white/20 text-white'
                : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300'">
            {{ item.badge }}
          </span>
          }

        </a>

        }
      </div>
    </div>
    }

  </nav>

  <!-- Bottom Footer -->
  <div class="shrink-0 space-y-1 border-t border-gray-100 dark:border-gray-800 p-3.5">

    <!-- Existing bottom menu items -->
    @if (bottomMenuItems && bottomMenuItems.length > 0) {
    @for (item of bottomMenuItems; track $index) {
    <a [pTooltip]="!isOpen ? item.label : ''" tooltipPosition="right" [attr.aria-label]="item.label"
      class="flex csr items-center rounded-xl transition-colors duration-150 cursor-pointer whitespace-nowrap text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800/70 font-medium"
      [ngClass]="isOpen ? 'gap-3.5 px-3.5 py-3' : 'justify-center px-0 py-3'">
      <i [class]="item.icon + ' text-xl shrink-0 text-gray-700 dark:text-gray-300'"></i>
      @if (isOpen) {
      <span class="text-sm font-medium tracking-tight truncate">{{ item.label }}</span>
      }
    </a>
    }
    }

    <!-- User + Logout -->
    <!-- <div class="flex items-center gap-3 rounded-xl" [ngClass]="isOpen ? 'px-1.5 py-2' : 'justify-center py-2'">
      @if (isOpen) {
      <span
        class="w-10 h-10 min-w-10 rounded-full bg-gray-700 dark:bg-gray-700 text-gray-200 ti ti-user-filled flex items-center justify-center text-2xl"></span>
      <div class="flex flex-col flex-1 min-w-0">
        <span class="text-sm font-medium tracking-tight truncate text-gray-800 dark:text-gray-100">{{ userFullName()
          }}</span>
        <span class="text-xs text-gray-500 dark:text-gray-400">{{ 'Admin' }}</span>
      </div>
      <p-button text="true" icon="ti ti-logout text-xl" pTooltip="Logout" severity="danger" (click)="onLogout()" />
      } @else {
      <span
        class="w-10 h-10 min-w-10 rounded-full bg-gray-700 text-gray-200 ti ti-user-filled flex items-center justify-center text-2xl"
        [pTooltip]="userFullName() || 'User'" tooltipPosition="right"></span>
      }
    </div> -->

    <!-- Privacy Policy -->
    <a href="javascript:void(0)" (click)="onPrivacyPolicyClick()" [pTooltip]="!isOpen ? 'Privacy Policy' : ''"
      tooltipPosition="right" aria-label="Privacy Policy"
      class="flex csr items-center rounded-xl transition-colors duration-150 cursor-pointer whitespace-nowrap"
      [ngClass]="[
            isOpen ? 'gap-3.5 px-3.5 py-3' : 'justify-center px-0 py-3',
            'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800/70 font-medium'
        ]">
      <i class="ti ti-shield text-xl shrink-0" [ngClass]="'text-gray-700 dark:text-gray-300'"></i>

      @if (isOpen) {
      <span class="text-sm font-medium tracking-tight truncate">
        Privacy Policy
      </span>
      }
    </a>


    <!-- Powered by -->
    <div class="flex pt-2 pb-1 gap-2" [ngClass]="isOpen ? 'items-center px-3.5' : 'flex-col items-center'">
      @if (isOpen) {
      <span class="text-xs text-gray-400 dark:text-gray-500 whitespace-nowrap">
        Powered by
      </span>
      <div class="h-6 flex items-center ml-auto">
        <img src="common-logos/vd-logo.svg" alt="Vassar Digital.ai" class="h-6 w-auto object-contain">
      </div>
      } @else {
      <div class="w-6 h-6 flex items-center justify-center" [pTooltip]="'Powered by Vassar Digital.ai'"
        tooltipPosition="right">
        <img src="common-logos/vd-logo-icon.svg" alt="Vassar" class="h-6 w-6 object-cover object-left">
      </div>
      }
    </div>

  </div>
</aside>